import {Radio, Stack} from '@mantine/core';
import React from 'react';

import {WebhookUrlRouting} from 'graphql-client/__generated/graphqlGlobalTypes';

export interface WebhookUrlRoutingRadioGroupProps {
  /**
   * The current value from the backend. Treats `null`/`undefined` as `SUFFIXED`,
   * matching the App Catalog default for app definitions that have not opted
   * into a routing strategy yet.
   */
  webhookUrlRouting: WebhookUrlRouting | null | undefined;
  onUpdateWebhookUrlRouting: (newValue: WebhookUrlRouting) => void;
}

export default function WebhookUrlRoutingRadioGroup({
  webhookUrlRouting,
  onUpdateWebhookUrlRouting,
}: WebhookUrlRoutingRadioGroupProps): JSX.Element {
  const value = webhookUrlRouting ?? WebhookUrlRouting.SUFFIXED;

  return (
    <Radio.Group
      label="Webhook Routing Setting"
      value={value}
      onChange={(newValue) => {
        onUpdateWebhookUrlRouting(newValue as WebhookUrlRouting);
      }}
    >
      <Stack spacing="xs" mt="xs">
        <Radio
          value={WebhookUrlRouting.SUFFIXED}
          label="Suffixed"
          description={
            <>
              Appends a path suffix based on the kind of webhook (e.g. <code>/lifecycle</code>,{' '}
              <code>/event</code>, <code>/canvas</code>) to the configured webhook URL.
            </>
          }
        />
        <Radio
          value={WebhookUrlRouting.STABLE}
          label="Stable"
          description="Uses the bare webhook URL without path suffixes."
        />
      </Stack>
    </Radio.Group>
  );
}
